<template>
  <b-nav>
    <b-nav-item
        class="d-block-custom"
        to="/default_home">
      <i class="fa mr-2 fa-home text-black" font-scale="1"></i>Home
    </b-nav-item>
  </b-nav>
</template>
<script>
export default {
  name: 'top-home-default-group'
}
</script>